export enum EventsNames {
  UserClicksButtonOnMainPage = "User clicks on the ‘I want to assign a lesson’ button on the landing page",
  UserClicksStudentsInMenu = "User clicks ‘Students’ in the menu",
  UserClicksAddStudent = "User clicks on ‘add student’",
  UserClicksSaveCreateStudentPage = "User clicks ‘save’ on the ‘create student page",
  UserClicksOkOnPopupAfterStudentCreate = "User clicks on the ‘ok’ button pop up after creating a student",
  UserClicksEditStudent = "User clicks on ‘edit student’",
  UserClicksOkOnPopupAfterStudentEdit = "User clicks on the ‘ok’ button pop up after editing a student",
  UserClicksDeleteStudentButton = "User clicks on ‘delete student’ button",
  UserClicksOkOnPopupAfterStudentDelete = "User clicks ‘ok’ ok the pop up to confirm deletion of the student/s",
  UserClicksNextOnStep1Class = "User clicks on the button in step 1 of adding a group (they have created the group name)",
  UserClicksClassesInMenu = "User clicks ‘Groups’ in the menu",
  UserClicksAddClass = "User clicks on ‘add group",
  UserClicksNextOnStep2Class = "User clicks on the button in step 2 of adding a group (they have selected the students)",
  UserClicksNextOnStep3Class = "User clicks on the button in step 3 of adding a group (they have selected the teachers)",
  UserClicksNextOnStep4Class = "User clicks on the button in step 4 of adding a group (they have seen the summary screen and are confirming the group creation)",
  UserClicksOkOnPopupAfterClassCreate = "User clicks on the button in the pop up after creating a group",
  UserClicksTeachersInMenu = "User clicks ‘Teachers’ in the menu",
  UserClicksAddTeacher = "User clicks on ‘add teacher’",
  UserClicksSaveOnCreateTeacherPage = "User clicks ‘save’ on the ‘create teacher page",
  UserClicksOkOnPopupAfterTeacherCreate = "User clicks on the ‘ok’ button pop up after creating a teacher",
  UserClicksEditTeacher = "User clicks on ‘edit teacher’",
  UserClicksOkOnPopupAfterTeacherEdit = "User clicks on the ‘ok’ button pop up after editing a teacher",
  UserClicksDeleteTeacher = "User clicks on ‘delete teacher’ button",
  UserClicksOkOnPopupAfterTeacherDelete = "User clicks ‘ok’ ok the pop up to confirm deletion of the teacher/s",
  UserClicksLessonsInMenu = "User clicks on ‘lessons’ in the menu",
  UserClicksAssignMyself = "User clicks on the ‘I want to assign lessons myself’",
  UserClicksViewActivityThumbnails = "User clicks on the ‘view activity thumbnails’ button",
  UserClicksViewPdf = "User clicks on the view PDF button",
  UserClicksZip = "User clicks on the download .zip folder button",
  UserClicksNextOnLessons = "User clicks on the ‘next step’ button to proceed to the lesson assignment summary page",
  UserClicksAssignLesson = "User clicks on ‘assign lesson’ to assign the lesson",
  UserClicksAssignAnotherLesson = "User clicks on the ‘assign another lesson’ button on the pop up that appears after assigning a lesson",
  UserClicksReportsInMenu = "User clicks on ‘reports’ in the menu",
  UserClicksOnGenerateReport = "User clicks on ‘generate report’",
  UserClicksPdfLevelReport = "User clicks on download PDF - Level report",
  UserClicksPdfUnitReport = "User clicks on download PDF - Unit report",
  UserClicksPdfLessonReport = "User clicks on download PDF - Lesson report",
  UserClicksCsvLevelReport = "User clicks on download CSV - Level report",
  UserClicksCsvUnitReport = "User clicks on download CSV - Unit report",
  UserClicksCsvLessonReport = "User clicks on download CSV - Lesson report",
  UserClicksViewLessonPlanLessonReport = "User clicks on ‘view lesson plan’ on the Lesson report screen",
  UserClicksGrammarToGoInMenu = "User clicks 'Grammar to go' in the menu",
  UserClicksKnowledgeBaseInMenu = "User clicks 'Knowledge base' in the menu"
}

const eventCodes: Record<EventsNames, string> = {
  [EventsNames.UserClicksButtonOnMainPage]: "TD1",
  [EventsNames.UserClicksStudentsInMenu]: "TD2",
  [EventsNames.UserClicksAddStudent]: "TD3",
  [EventsNames.UserClicksSaveCreateStudentPage]: "TD4",
  [EventsNames.UserClicksOkOnPopupAfterStudentCreate]: "TD5",
  [EventsNames.UserClicksEditStudent]: "TD6",
  [EventsNames.UserClicksOkOnPopupAfterStudentEdit]: "TD7",
  [EventsNames.UserClicksDeleteStudentButton]: "TD8",
  [EventsNames.UserClicksOkOnPopupAfterStudentDelete]: "TD9",
  [EventsNames.UserClicksClassesInMenu]: "TD10",
  [EventsNames.UserClicksAddClass]: "TD11",
  [EventsNames.UserClicksNextOnStep1Class]: "TD12",
  [EventsNames.UserClicksNextOnStep2Class]: "TD13",
  [EventsNames.UserClicksNextOnStep3Class]: "TD14",
  [EventsNames.UserClicksNextOnStep4Class]: "TD15",
  [EventsNames.UserClicksOkOnPopupAfterClassCreate]: "TD16",
  [EventsNames.UserClicksTeachersInMenu]: "TD17",
  [EventsNames.UserClicksAddTeacher]: "TD18",
  [EventsNames.UserClicksSaveOnCreateTeacherPage]: "TD19",
  [EventsNames.UserClicksOkOnPopupAfterTeacherCreate]: "TD20",
  [EventsNames.UserClicksEditTeacher]: "TD21",
  [EventsNames.UserClicksOkOnPopupAfterTeacherEdit]: "TD22",
  [EventsNames.UserClicksDeleteTeacher]: "TD23",
  [EventsNames.UserClicksOkOnPopupAfterTeacherDelete]: "TD24",
  [EventsNames.UserClicksLessonsInMenu]: "TD25",
  [EventsNames.UserClicksAssignMyself]: "TD26",
  [EventsNames.UserClicksViewActivityThumbnails]: "TD27",
  [EventsNames.UserClicksViewPdf]: "TD28",
  [EventsNames.UserClicksZip]: "TD29",
  [EventsNames.UserClicksNextOnLessons]: "TD30",
  [EventsNames.UserClicksAssignLesson]: "TD31",
  [EventsNames.UserClicksAssignAnotherLesson]: "TD32",
  [EventsNames.UserClicksReportsInMenu]: "TD33",
  [EventsNames.UserClicksOnGenerateReport]: "TD34",
  [EventsNames.UserClicksPdfLevelReport]: "TD35",
  [EventsNames.UserClicksPdfUnitReport]: "TD36",
  [EventsNames.UserClicksPdfLessonReport]: "TD37",
  [EventsNames.UserClicksCsvLevelReport]: "TD38",
  [EventsNames.UserClicksCsvUnitReport]: "TD39",
  [EventsNames.UserClicksCsvLessonReport]: "TD40",
  [EventsNames.UserClicksViewLessonPlanLessonReport]: "TD41",
  [EventsNames.UserClicksGrammarToGoInMenu]: "TD43",
  [EventsNames.UserClicksKnowledgeBaseInMenu]: "TD56"
};

export const eventCodeByName = (name: EventsNames) => eventCodes[name];
